module.exports = __webpack_public_path__ + "img/删除.a1f83e60.svg";